import script from "./CommunityWriteView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityWriteView.vue?vue&type=script&setup=true&lang=js"

import "./CommunityWriteView.vue?vue&type=style&index=0&id=46c13afe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c13afe"]])

export default __exports__